import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getLines, getAreas, getMachines, getMachinesByLineArea } from "./equipmentApi";
export const equipmentSlice = createSlice({
    name: 'equipment',
    initialState: {
        currentLine: "",
        currentArea: "",
        currentMachine: "",
        currentMachineId: 0,
        confirmedMachine: "",
        confirmedMachineId: 0,
        isFind: false,
        isQr: false,
        isManual: false,
        lines: [],
        areas: [],
        machines: []



    },
    reducers: {
        setCurrentArea: (state, action) => {
            state.currentArea = action.payload
        },
        setCurrentLine: (state, action) => {
            state.currentLine = action.payload
        },
        setCurrentMachine: (state, action) => {
            state.currentMachine = action.payload
        },
        setConfirmedMachine: (state, action) => {
            state.confirmedMachine = action.payload.name
            state.confirmedMachineId = action.payload.id
        },
        writeConfirmedMachineFromCurrent: (state) => {
            state.confirmedMachine = state.currentMachine
            state.confirmedMachineId = state.currentMachineId
        },
        setCurrentMachine: (state, action) => {
            state.currentMachine = action.payload
        },
        resetSearch: (state) => {
            state.lines = ""
            state.areas = ""
            state.machines = ""
            state.currentMachine = ""
        },
        resetQR: (state) => {
            state.isQr = false
        },
        resetAllEquipment: (state) => {
            state.currentLine = ""
            state.currentArea = ""
            state.currentMachine = ""
            state.currentMachineId = 0
            state.confirmedMachine = ""
            state.confirmedMachineId = 0
            state.isFind = false
            state.isQr = false
            state.isManual = false
            state.lines = []
            state.areas = []
            state.machines = []
        },
        active: (state) => {
            state.isManual = true
        },
        deactive: (state) => {
            state.isManual = false
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getLines.fulfilled, (state, action) => {

            console.log(action.payload)
            state.lines = action.payload
            state.isManual = true
            console.log('SUCCESS getLines')


            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(getLines.pending, (state, action) => {
        })

        builder.addCase(getLines.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });

        })
        builder.addCase(getAreas.fulfilled, (state, action) => {

            console.log(action.payload)
            state.areas = action.payload

            console.log('SUCCESS getAreas')


            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(getAreas.pending, (state, action) => {
        })

        builder.addCase(getAreas.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        })

        builder.addCase(getMachines.fulfilled, (state, action) => {

            console.log(action.payload)
            state.machines = action.payload

            console.log('SUCCESS getMachines')


            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(getMachines.pending, (state, action) => {
        })

        builder.addCase(getMachines.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        })

        builder.addCase(getMachinesByLineArea.fulfilled, (state, action) => {



            console.log(action.payload)
            console.log(action)
            state.machines = action.payload
            if (action.payload.length > 0) {
                state.isQr = true
                state.currentMachine = action.payload[0].name
                state.currentMachineId = action.payload[0].id
            }

            console.log('SUCCESS getMachinesByLineArea')





            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(getMachinesByLineArea.pending, (state, action) => {
            state.isQr = false


        })

        builder.addCase(getMachinesByLineArea.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()

                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        })
    }
})


export const { resetAllEquipment, active, deactive, setCurrentMachine, resetSearch, resetQR, setConfirmedMachine, writeConfirmedMachineFromCurrent, setCurrentArea, setCurrentLine } = equipmentSlice.actions

export default equipmentSlice.reducer
